import React from 'react';
import PreAp from '../containers/PreApContainer';

const PreApAppClient = (props) => (
  <PreAp {...props} />
);

export default PreApAppClient;
